export function idFromUri(uri: string): string {
  const match = uri.match(/^(?:\w+:\/\/)([^/?]+)/);
  if (match) return match[1];
  throw Error(`Resource id could not be found for URI ${uri}`);
}

export function schemeFromUri(uri: string): string {
  const match = uri.match(/^(\w+):\/\//);
  return match?.[1] ?? '';
}

export function sharableLinkDownloadUrl(link: string): string {
  const url = new URL(link);
  url.searchParams.set('download', '1');
  return url.toString();
}

export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleString();
}

export function getDurationString(startedAt: string | null | undefined, endedAt: string | null | undefined): string {
  if (!startedAt || !endedAt) return '';
  const start = new Date(startedAt);
  const end = new Date(endedAt);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return '';
  const diffMs = end.getTime() - start.getTime();
  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}
